// extracted by mini-css-extract-plugin
export default {"list-item":"ticket-action_list-item__Hmtge","listItem":"ticket-action_list-item__Hmtge"};